/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Restore_LineInputs */

const vi_einvoice_draft_restore_line = /** @type {(inputs: Einvoice_Draft_Restore_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tác`)
};

/**

* @param {Einvoice_Draft_Restore_LineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_restore_line = /** @type {((inputs?: Einvoice_Draft_Restore_LineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Restore_LineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_restore_line(inputs)
});